import { toast } from "react-toastify";

/**
 * Baixa o arquivo de uma nota fiscal: na aba Pagamentos do contrato e no detalhe
 * do pagamento.
 *
 * - storedFilename: nome real do arquivo salvo no disco/S3 (o fim do `document_uri`)
 * - displayFilename: nome original, para o atributo download
 * - userId: do `document_uri` (posição [2] em 'public/tax-invoices/{userId}/...')
 *
 * @param {object} taxInvoicesService - `useService("taxInvoices")`
 * @param {object} invoice - nota como vem da API
 */
export async function downloadTaxInvoice(taxInvoicesService, invoice) {
  try {
    const storedFilename = invoice.document_uri ? invoice.document_uri.split("/").reverse()[0] : invoice.filename;
    const displayFilename = invoice.filename || storedFilename;
    const userId = invoice.user_id || (invoice.document_uri ? invoice.document_uri.split("/")[2] : null);
    const result = await taxInvoicesService.getDocument(storedFilename, userId);
    if (result?.url) {
      // S3: abre a URL presigned diretamente (sem enviar header Authorization)
      const link = document.createElement("a");
      link.href = result.url;
      link.setAttribute("download", displayFilename);
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (result instanceof Blob) {
      // Armazenamento local: usa blob
      const href = URL.createObjectURL(result);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", displayFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    }
  } catch (err) {
    console.error(err);
    toast.error("Erro ao baixar nota fiscal");
  }
}
